import { CSSProperties, TableHTMLAttributes } from 'react';
import classNames from 'classnames';

import { isDefined } from '@/utils/is-defined';

import className from './layout-table-row.module.css';

interface TableRowProps extends TableHTMLAttributes<HTMLTableRowElement> {
  backgroundColor?: CSSProperties['backgroundColor'];
  hoverBackgroundColor?: CSSProperties['backgroundColor'];
  focusWithinBackgroundColor?: CSSProperties['backgroundColor'];
}

const TableRow = ({
  backgroundColor,
  hoverBackgroundColor,
  focusWithinBackgroundColor,
  children,
  ...props
}: TableRowProps) => {
  return (
    <tr
      {...props}
      className={classNames(
        className['bl-table-row'],
        {
          [className['no-border']]: props?.border === 0,
          [className['has-background-color']]: !!backgroundColor,
          [className['has-hover-background-color']]: !!backgroundColor,
          [className['has-focus-within-background-color']]: !!focusWithinBackgroundColor,
        },
        props.className
      )}
      style={
        {
          ...(isDefined(backgroundColor) ? { '--table-row-background-color': backgroundColor } : {}),
          ...(isDefined(hoverBackgroundColor) ? { '--table-row-hover-background-color': hoverBackgroundColor } : {}),
          ...(isDefined(focusWithinBackgroundColor)
            ? { '--table-row-focus-within-background-color': focusWithinBackgroundColor }
            : {}),
          ...props.style,
        } as CSSProperties
      }
    >
      {children}
    </tr>
  );
};

export default TableRow;
